// Vorgänge und Vorlagen der E-Signatur, mit Vorschaubildern (nacheinander, selbstheilend).

import { useCallback, useEffect, useRef, useState } from 'react';
import { ladeSignaturVorgaenge, ladeVorschaubild } from './signaturApi';
import { meldeDokumenteGeaendert } from './useDokumenteKopf';
import type { SignaturVorgang } from './signaturTypen';

export function useSignaturVorgaenge() {
  const [liste, setListe] = useState<SignaturVorgang[] | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [bilder, setBilder] = useState<Record<string, string>>({});
  const [runde, setRunde] = useState(0);
  const bilderRef = useRef(bilder);
  bilderRef.current = bilder;
  const geladen = useRef(new Set<string>());

  useEffect(() => {
    let aktiv = true;
    ladeSignaturVorgaenge()
      .then(async l => {
        if (!aktiv) return;
        setListe(l); setFehler(null);
        for (const v of l) {
          // Neu laden, wenn sich das Vorschaubild geändert haben kann (z. B. abgeschlossen → signiertes PDF)
          const schluessel = `${v.id}|${v.vorschau_path ?? ''}|${v.status}`;
          if (geladen.current.has(schluessel)) continue;
          try {
            const url = await ladeVorschaubild(v);
            if (!aktiv) { if (url) URL.revokeObjectURL(url); return; }
            geladen.current.add(schluessel);
            if (url) setBilder(alt => { if (alt[v.id]) URL.revokeObjectURL(alt[v.id]); return { ...alt, [v.id]: url }; });
          } catch (e) { console.warn('Vorschau fehlgeschlagen', v.id, e); }
        }
      })
      .catch((e: unknown) => { if (aktiv) setFehler(e instanceof Error ? e.message : 'Vorgänge nicht geladen'); });
    return () => { aktiv = false; };
  }, [runde]);
  useEffect(() => () => { Object.values(bilderRef.current).forEach(u => URL.revokeObjectURL(u)); }, []);

  /** Nach Änderungen: Liste neu und Kopf/Widgets informieren. */
  const neuLaden = useCallback(() => { setRunde(r => r + 1); meldeDokumenteGeaendert(); }, []);
  return { liste, fehler, bilder, neuLaden };
}
